import React from 'react';
import {
  Button
} from "@material-tailwind/react";
import HomeImage from '../../../images/HomeImage.jpg';

const HomeIntroduction = () => {
  return (
	<div className="w-full md:pt-5 md:bg-[radial-gradient(169.40%_89.55%_at_94.76%_6.29%,#c09b79_0%,rgba(255,255,255,0.00)_100%)]">
		<div className="relative mx-auto w-full md:w-4/6 shadow-lg">
			<img alt="nature" className="rounded-xl w-full top-0 bottom-0 left-0 right-0 -z-10" src={HomeImage}/>
			<span className="w-full h-full z-0 rounded-xl bg-white absolute top-0 bg-opacity-50 left-0"/>
			<div className="absolute top-[5%] left-4 md:left-10 z-10 text-left">
				<h1 className="mb-2 text-3xl font-extrabold leading-none tracking-tight text-gray-900 md:text-5xl lg:text-8xl dark:text-white [text-shadow:_3px_3px_3px_rgb(180_180_180_/_90%)]">La tournée d&apos;accord</h1>
				<a className="hidden" href="/ContactForm"><Button className="align-left">Programmer un RDV</Button></a>
				<ul className="mt-4">
					<li className="text-sm md:text-lg lg:text-4xl ml-4 mb-0 md:mb-2 font-extrabold dark:text-white">Accord de piano</li>
					<li className="text-sm md:text-lg lg:text-4xl ml-8 mb-0 md:mb-2 font-extrabold dark:text-white">Réparations</li>
					<li className="text-sm md:text-lg lg:text-4xl ml-12 mb-0 md:mb-2 font-extrabold dark:text-white">Conseil &amp; Entretien</li>
				</ul>
			</div>
		</div>
	</div>
  );
};

export default HomeIntroduction;